import { UserProfile } from '../../../types';
import { api } from '../../d1';

export class D1ProfileRepo {
    async getUserProfile(): Promise<UserProfile | null> {
        // Safe stub returning default or undefined
        return {
            id: '',
            name: '',
            email: '',
            phone: '',
            isVerified: false,
            memberSince: new Date().getFullYear().toString()
        };
    }

    async updateUserProfile(profile: Partial<UserProfile>): Promise<UserProfile> {
        return { ...await this.getUserProfile(), ...profile };
    }

    async getAllUserProfiles(): Promise<UserProfile[]> {
        return [];
    }

    async syncAuth(data: { email?: string; name?: string; notify_on_message?: boolean; notify_on_status_change?: boolean }): Promise<void> {
        try {

            await api.auth.sync(data);
        } catch (e) {
            console.error('D1 syncAuth error', e);
        }
    }
}
